import personalWeb from '../images/personalWeb.PNG'
import extention from '../images/extension.PNG'
import tenzies from '../images/tenzies.PNG'
import fitMeUp from '../images/fitMeUp.PNG'
import portfilo from '../images/portfilo.PNG'
import catchMe from '../images/catchMe.PNG'
import ragingSea from '../images/ragingSea.png'
import galaxy from '../images/galaxy.png'
import smoke from '../images/smoke.png'
import earth from '../images/earth.png'
import liquid from '../images/liquid.png'
import gpgpu from '../images/gpgpu.png'
import wobble from '../images/wobble.png'
import terrain from '../images/terrain.png'
import portal from '../images/portal.png'
import laptop from '../images/laptop.png'
import thunderstore from '../images/thunderstore.png'

const data = [
    {
        id:1,
        img:personalWeb,
        title:'Personal Website (old)',
        description:'An old personal website',
        url:'https://imyosrii.github.io/',
        date:'2022/Jun/1'
    },
    {
        id:2,
        img:extention,
        title:'Tasks manager chrome extention',
        description:'extention that helps manage your time and tasks',
        url:'https://github.com/ImYosrii/Tasks-Manager-extension-',
        date:'2022/Jun/20'
    },
    {
        id:3,
        img:tenzies,
        title:'Tenzies',
        description:'A game where you math dice by hold and rerolling until they all match',
        url:'https://github.com/ImYosrii/Tenzies',
        date:'2022/Jul/19'
    },
    {
        id:4,
        img:fitMeUp,
        title:'Fit Me Up',
        description:'An exercising website that offers 1300+ exercises with offering youtube videos for each exercise',
        url:'https://fit-me-up.netlify.app/',
        date:'2022/Aug/28'
    },
    {
        id:5,
        img:portfilo,
        title:'Personal Website',
        description:'A new personal website',
        url:'https://github.com/ImYosrii/portfolio',
        date:'2022/Aug/30'
    },
    {
        id:6,
        img:catchMe,
        title:'Catch Me if you Scan',
        description:'An exciting game that allows you to compete with your friends to become the ultimate monster collector.',
        url:'https://github.com/CMPUT301W23T07/catch-me-if-you-scan',
        date:'2023/Mar/3'
    },
    {
        id:7,
        img:ragingSea,
        title:'Raging Sea GLSL Shader',
        description:'A raging sea shader made with GLSL shaders and ThreeJS, with Lil-gui controls panel.',
        url:'https://sea-waves-3d.netlify.app/',
        date:'2025/Jan/4'
    },
    {
        id:8,
        img:galaxy,
        title:'Galaxy Generator GLSL Shader',
        description:'A galaxy generator shader made with GLSL shaders and ThreeJS, with Lil-gui controls panel.',
        url:'https://galaxy-generator-3d.netlify.app/',
        date:'2025/Jan/5'
    },
    {
        id:9,
        img:smoke,
        title:'Coffee Smoke GLSL Shader',
        description:'A coffee smoke shader made with GLSL shaders, Simplex Noise and ThreeJS.',
        url:'https://smoke-shader.netlify.app/',
        date:'2025/Jan/9'
    },
    {
        id:10,
        img:earth,
        title:'A Rotating Earth with Sun GLSL Shader',
        description:'A rotating earth with sun shader made with GLSL shaders and ThreeJS.',
        url:'https://earth-shader.netlify.app/',
        date:'2025/Jan/13'
    },
    {
        id:11,
        img:liquid,
        title:'A Raging Sea but with custom Lights GLSL Shader',
        description:'A raging sea but with custom lights shader made with GLSL shaders and ThreeJS.',
        url:'https://sea-shader.netlify.app/',
        date:'2025/Jan/13'
    },
    {
        id:12,
        img:gpgpu,
        title:'A GLSL shader that follows GPGPU principles to simulate particles flow movement calculations using the GPU',
        description:'shader made with GLSL shaders and ThreeJS that turns any model into a moving particles.',
        url:'https://gpgpu-flow.netlify.app/',
        date:'2025/Jan/21'
    },
    {
        id:13,
        img:wobble,
        title:'A GLSL shader that simulates wobble movement on models',
        description:'shader made with GLSL shaders and ThreeJS that simulates random wobble movements.',
        url:'https://wobble-shader.netlify.app/',
        date:'2025/Jan/22'
    },
    {
        id:14,
        img:terrain,
        title:'A GLSL shader that simulates random Terrains',
        description:'shader made with GLSL shaders and ThreeJS that simulates random terrain using Simplex Noise.',
        url:'https://terrain-shader.netlify.app/',
        date:'2025/Jan/24'
    },
    {
        id:15,
        img:portal,
        title:'Portal scene with custom portal GLSL Shaders.',
        description:'A Portal model that was created and baked its textures in Blender and rendered with ThreeJS with custom GLSL shaders for the portal effect and then rendered in React-Three-Fiber (R3F).',
        url:'https://r3f-my-portal-scene.netlify.app/',
        date:'2025/Feb/17'
    },
    {
        id:16,
        img:laptop,
        title:'A 3D Portfolio.',
        description:'A laptop model that shows my original portfolio using iFrame tag. Website was created using R3F and Drei',
        url:'https://yosri-swidan-3d.netlify.app/',
        date:'2025/Mar/2'
    },
    {
        id: 17,
        img: thunderstore,
        title: 'A 3D E-commerce shoe customization website.',
        description: 'A shoe customization website that allows you to customize your shoe and see it in 3D using ThreeJS and React-Three-Fiber (R3F).',
        url: 'https://thundersotore-3d.netlify.app/',
        date: '2025/Mar/18'
    }
]
export default data